import * as yup from 'yup';

export const passportNameFields = [
  {
    name: 'primerNombrePersona',
    label: 'Primer nombre',
    source: 'ClientePrimerNombre',
    required: true,
  },
  { name: 'segundoNombrePersona', label: 'Segundo nombre', source: 'ClienteSegundoNombre' },
  {
    name: 'primerApellidoPersona',
    label: 'Primer apellido',
    source: 'ClientePrimerApellido',
    required: true,
  },
  { name: 'segundoApellidoPersona', label: 'Segundo apellido', source: 'ClienteSegundoApellido' },
];

const normalizeName = (value) => (value ?? '').trim().replace(/\s+/g, ' ');

const emissionNameMapping = {
  primerNombrePersona: 'firstName',
  segundoNombrePersona: 'secondName',
  primerApellidoPersona: 'surname',
  segundoApellidoPersona: 'secondSurname',
};

export const emissionPassportNameFields = passportNameFields.map((field) => ({
  ...field,
  name: emissionNameMapping[field.name],
}));

export const getPassportNameValues = (values = {}, fields = passportNameFields) =>
  Object.fromEntries(fields.map(({ name }) => [name, normalizeName(values[name])]));

export const getPassportFullName = (values, fields = passportNameFields) =>
  Object.values(getPassportNameValues(values, fields)).filter(Boolean).join(' ');

const createPassportNameSchema = (fields) =>
  yup.object().shape(
    Object.fromEntries(
      fields.map(({ name, required }) => {
        const schema = yup
          .string()
          .transform((value) => normalizeName(value))
          .max(60, 'Este campo admite hasta 60 caracteres')
          .matches(/^[\p{L}\p{M}]+(?:[ '-][\p{L}\p{M}]+)*$/u, {
            message: 'Ingresa únicamente letras',
            excludeEmptyString: true,
          });

        return [name, required ? schema.required('Este campo no puede quedar vacío') : schema];
      }),
    ),
  );

export const passportNameSchema = createPassportNameSchema(passportNameFields);
export const emissionPassportNameSchema = createPassportNameSchema(emissionPassportNameFields);

export const getPersonNameDefaults = (personPage, quotationRequest) =>
  Object.fromEntries(
    passportNameFields.map(({ name, source }) => [
      name,
      personPage?.[source]?.trim()?.toLowerCase() ||
        (quotationRequest?.idType === '3' ? normalizeName(quotationRequest[name]) : ''),
    ]),
  );
